// Decide o destino após o login: se o único assistente acessível ao usuário
// for o chat genérico (id "0"), abre o chat diretamente, sem passar pelo hub.
export function getPostLoginDestination(assistants, role) {
  const list = assistants || [];

  if (list.length === 1 && String(list[0].id) === '0') {
    return {
      path: '/siteAssist',
      state: { assistantId: list[0].id, assistantIcon: list[0].icon, assistantName: list[0].nome },
    };
  }

  // role "externo" com exatamente 1 assistente compartilhado vai direto para o assistente
  if (role === 'externo' && list.length === 1) {
    const [assistant] = list;
    const state = { assistantId: assistant.id, assistantIcon: assistant.icon, assistantName: assistant.nome };

    return assistant.type === 'classifier' ? { path: '/category', state }
      : assistant.type === 'automation' ? { path: '/automation', state }
      : assistant.type === 'sabesp_nts' ? { path: '/sabesp', state }
      : { path: '/siteAssist', state };
  }

  return { path: '/hub', state: undefined };
}
